'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247 from "./presto.-Two-Factor-Auth-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$6(outer) {
  this.bEY = null;
  this.bEW = null;
  this.bEX = false;
  this.bEU = null;
  this.bEV = false;
  this.bEZ = false;
  this.bF0 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bEY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$6 as $c_Lpresto_TwoFactorAuthView$$anon$6 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$6;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$6() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$6 as $h_Lpresto_TwoFactorAuthView$$anon$6 };
$h_Lpresto_TwoFactorAuthView$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bEY;
});
$p.t = (function() {
  if ((!this.bEX)) {
    this.bEW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seeds", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("invites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bEX = true;
  }
  return this.bEW;
});
$p.ad = (function() {
  if ((!this.bEV)) {
    this.bEU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247.$c_Lpresto_TwoFactorAuthView$$anon$7()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bEV = true;
  }
  return this.bEU;
});
$p.v = (function() {
  if ((!this.bF0)) {
    this.bEZ = false;
    this.bF0 = true;
  }
  return this.bEZ;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$6, "presto.TwoFactorAuthView$$anon$6", ({
  Tk: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$6 as $d_Lpresto_TwoFactorAuthView$$anon$6 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$6.js.map
